import { ADS_CAMPAIGN_STATUS_DRAFT } from "../../../utils/constants";
import { getGlobalReportCampaignCounts } from "./getGlobalReportCampaignCounts";

const isTimestampInRange = (timestamp, startDateTime, endDateTime) => {
  if (!timestamp || !startDateTime || !endDateTime) {
    return false;
  }

  const value = new Date(timestamp).getTime();
  const start = new Date(startDateTime).getTime();
  const end = new Date(endDateTime).getTime();

  return value >= start && value <= end;
};

export const getNonDraftCampaignIDs = (campaigns = {}) =>
  Object.keys(campaigns).filter(
    (campaignID) =>
      campaigns[campaignID]?.states?.general !== ADS_CAMPAIGN_STATUS_DRAFT
  );

export const buildGlobalReportPortfolioSnapshot = ({
  campaigns = {},
  dateRange,
  totals = {},
  totalsLastPeriod = null,
}) => {
  const { startDateTime, endDateTime } = dateRange || {};
  const counts = getGlobalReportCampaignCounts(campaigns);

  let createdInRange = 0;
  let activeInRange = 0;

  Object.values(campaigns).forEach((campaign) => {
    if (campaign?.states?.general === ADS_CAMPAIGN_STATUS_DRAFT) {
      return;
    }

    if (isTimestampInRange(campaign.creationTime, startDateTime, endDateTime)) {
      createdInRange += 1;
    }

    if (
      isTimestampInRange(campaign.lastActiveTime, startDateTime, endDateTime)
    ) {
      activeInRange += 1;
    }
  });

  const snapshot = {
    totalCampaignsInRange: counts.total,
    activeCampaigns: counts.active,
    pausedCampaigns: counts.paused,
    createdInRange,
    activeInRange,
    totals: {
      impressions: totals.impressions ?? 0,
      clicks: totals.clicks ?? 0,
      mainAction: totals.mainAction ?? 0,
      spend: totals.spend ?? {},
      spendByPlatform: totals.spendByPlatform ?? {},
      roas: totals.roas ?? 0,
    },
    campaignIDs: getNonDraftCampaignIDs(campaigns),
  };

  if (totalsLastPeriod) {
    snapshot.totalsLastPeriod = {
      impressions: totalsLastPeriod.impressions ?? 0,
      clicks: totalsLastPeriod.clicks ?? 0,
      mainAction: totalsLastPeriod.mainAction ?? 0,
      spend: totalsLastPeriod.spend ?? {},
      roas: totalsLastPeriod.roas ?? 0,
    };
  }

  return snapshot;
};
